import { OfferedServiceBase } from "../json-schemas/base/offered_service"
import { ParticipantBase } from "../json-schemas/base/participant"
import { ParticipantShowResponse } from "../json-schemas/serializers/participant-show-response"
import { httpPatch, httpPost } from "../utils/http.service"
import { I18nService } from "../utils/i18n.service"
import i18nScopedData from './participants.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

export function participantsSharedI18n (terminology: OfferedServiceBase['participant_terminology'] = 'participant') {
  return i18nScoped.scope(terminology).scope('shared')
}

export function participantCreate (body: any): Promise<ParticipantShowResponse> {
  return httpPost('/account/participants', { participant: body })
}

export function participantUpdate (body: any): Promise<ParticipantShowResponse> {
  return httpPatch(`/account/participants/${body.id}`, { participant: body })
}

export function participantI18nAssociationType (type: ParticipantBase['association_type']) {
  return i18nScoped.t('association_type.' + type)
}

export function participantI18nFieldName (fieldName: string) {
  return i18nScoped.t('fields_type.' + fieldName)
}
